import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { StationApp } from '../../../_models/fundraising/PosStation';
import { StationService } from '../../../_services/fundraising/station.service';
import { S3Service } from '../../../_services/s3.service';
import { mergeMap } from 'rxjs/operators'
import { Environment } from '../../../../environments/environment';

@Component({
  selector: 'app-station-app-upload-modal',
  templateUrl: './station-app-upload-modal.component.html',
  styleUrls: ['./station-app-upload-modal.component.css']
})

export class StationAppUploadModalComponent implements OnInit {

  public form: FormGroup;
  public submitted = false;
  public hasFormError = false;

  apkFile: File;

  currentVersion: string;

  @Output() hasError = new EventEmitter();

  constructor(
    private stationService: StationService,
    private bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private s3Service: S3Service
  ) { }

  ngOnInit() { 

    const versionSplit = this.currentVersion.split('.');

    this.form = this.fb.group({
      versionMajor: [versionSplit[0], Validators.required],
      versionMinor: [versionSplit[1], Validators.required],
      versionPoint: [versionSplit[2], Validators.required],
      description: ['', ],
      forceUpdate: [false, Validators.required],
      current: [true, Validators.required]
    });

  }

  versionChanged() {
    this.currentVersion = `${this.form.controls.versionMajor.value}.${this.form.controls.versionMinor.value}.${this.form.controls.versionPoint.value}`;
  }

  save() {
    if (this.form.invalid || !this.apkFile) {
      this.hasFormError = true;
      return;
    }

    this.hasFormError = false;
    this.submitted = true;

    const stationApp = new StationApp(this.form.getRawValue());
    stationApp.version = this.currentVersion;

    const apk = new File([this.apkFile], `${this.currentVersion}.apk`, {type: this.apkFile.type});

    this.s3Service.uploadFile(apk,`station-apps-${Environment.name}/${this.currentVersion}.apk`.toLowerCase().replace(/ /g, '-'), "get-signed-s3-url")
    .pipe(mergeMap(res => {
      return this.stationService.createNewStationApp(stationApp);
    }))
    .subscribe(
      res =>  this.close(),
      error => {
        this.hasError.emit(true);
        this.bsModalRef.hide();
      });
  }

  fileChange(files: FileList) {
    if (files.length > 0) {
      this.apkFile = files.item(0);
    }
  }

  close() {
    this.hasError.emit(false);
    this.bsModalRef.hide();
  }

}

